import React, {useContext, useEffect, useState} from 'react';
import Header from '../components/header';
import AuthContext from "./shared/AuthContext";
import {API} from "../services/api";
import {useNavigate} from "react-router-dom";
import Swal from "sweetalert2";
import {useTranslation} from "react-i18next";
import OrgContext from "../organisation/OrgContext";
import {toast, ToastContainer} from "react-toastify";

const UpClient = (props) => {
    const [t, i18n] = useTranslation();
    const [display, setDisplay] = useState(false);
    const [displayErrors, setDisplayErrors] = useState('none');
    const {user, logout} = useContext(AuthContext);
    const navigate = useNavigate();
    const { organisation, changeOrg } = useContext(OrgContext);

    const [client_id, setClientId] = useState(null);
    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [email, setEmail] = useState('');
    const [webSite, setWebSite] = useState('');
    const [ice,setIce] = useState('');

    const [facAdCountry, setFacAdCountry] = useState('');
    const [facAdCity, setFacAdCity] = useState('');
    const [facAdCodePostal, setFacAdCodePostal] = useState('');
    const [facAdOthers, setFacAdOthers] = useState('');

    const [livAdCity, setLivAdCity] = useState('');
    const [livAdCountry, setLivAdCountry] = useState('');
    const [livAdCodePostal, setLivAdCodePostal] = useState('');
    const [livAdOthers, setLivAdOthers] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(()=> {
        if(props.client){
            let client = props.client;
            setClientId(client?.id);
            setName(client?.name);
            setLastName(client?.lastName)
            setPhoneNumber(client?.phoneNumber)
            setCompanyName(client?.companyName)
            setEmail(client?.email)
            setWebSite(client?.website)
            setIce(client?.ice)
            setFacAdCountry(client?.addressFacCountry)
            setFacAdCity(client?.addressFacCity)
            setFacAdCodePostal(client?.addressFacCodePostal)
            setFacAdOthers(client?.addressFacOthers)
            setLivAdCountry(client?.addressLivCountry && client?.addressLivCountry ? client?.addressLivCountry : client?.addressFacCountry)
            setLivAdCity(client?.addressLivCity && client?.addressLivCity ? client?.addressLivCity : client?.addressFacCity)
            setLivAdCodePostal(client?.addressLivCodePostal && client?.addressLivCodePostal ? client?.addressLivCodePostal : client?.addressFacCodePostal)
            setLivAdOthers(client?.addressLivOthers && client?.addressLivOthers ? client?.addressLivOthers : client?.addressFacOthers)
        }
    }, []);

    const saveClient = async (client) => {
        setIsSubmit(true);
        const response = await API.post('/client/edit', client).then(res => {
            setIsSubmit(false);
            if(props.ocr){
                props.afterSave(client);
            }else{
                console.log(res);
                Swal.fire(
                    t('Le client a été ajouter avec succès'),
                    t(''),
                    'success'
                );
                navigate(-1)
            }
           
        }).catch((error) => {
            setIsSubmit(false);
            console.log(error)
        });
    }
    const Save = () => {
        if (name.length === 0 || email.length === 0 || companyName.length === 0 || phoneNumber.length === 0) {
            toast.error('Merci de verifier les champs obligatoire !', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } else {
            const preparedObject = {
                id: client_id,
                name: name,
                lastName: lastName === null ? "" : lastName,
                type: props.type,
                email: email,
                companyName: companyName,
                phoneNumber: phoneNumber,
                website: webSite,
                addressFacCountry: facAdCountry,
                addressFacCity: facAdCity,
                addressFacCodePostal: facAdCodePostal,
                addressFacOthers: facAdOthers,
                addressLivCountry: livAdCountry,
                addressLivCity: livAdCity,
                addressLivCodePostal: livAdCodePostal,
                addressLivOthers: livAdOthers,
                user_id: user.id
                ,ice: ice
                ,organization_id: organisation.id
            };
            saveClient(preparedObject);
        }
    };
    return (
        <>
            <ToastContainer/>
            <div style={{display: displayErrors}}>
                <div className="alert alert-danger alert-dismissible fade show mb-0" role="alert">
                    <span className="alert-inner--icon"><i className="fe fe-slash"></i></span>
                    <span className="alert-inner--text"><strong></strong> Les champs suivants sont obligatoire !</span>
                    <p>
                        <ul>
                            <li>- Nom</li>
                            <li>- Prénom</li>
                            <li>- E-mail du client</li>
                            <li>- Nom de la société</li>
                            <li>- Téléphone du client</li>
                            <li>- L'identifiant Commun de l'Entreprise</li>
                        </ul>
                    </p>
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <br/>
            </div>
            <div className="row">

                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title">Contact principal</div>
                        </div>
                        <div className="card-body">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Nom de la société*</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setCompanyName(e.target.value)} value={companyName}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Nom Complete Du Contact*</label>
                                <input onChange={(e) => setName(e.target.value)} value={name} type="text"
                                       placeholder="nom" className={`form-control `}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">E-mail du client*</label>
                                <input type="email"
                                       placeholder="" className={`form-control`}
                                       onChange={(e) => setEmail(e.target.value)} value={email}
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Téléphone du client*</label>
                                <input type="tel" className={`form-control`}
                                       onChange={(e) => setPhoneNumber(e.target.value)} value={phoneNumber}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">Site Internet</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setWebSite(e.target.value)} value={webSite}
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1" className="">L'identifiant Commun de l'Entreprise</label>
                                <input type="text" className={`form-control`}
                                       onChange={(e) => setIce(e.target.value)} value={ice}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title">ADRESSE DE FACTURATION</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">Pays / Région</span>
                                            <input type="text" className={`form-control`}
                                                   onChange={(e) => setFacAdCountry(e.target.value)}
                                                   value={facAdCountry}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>Ville</label>
                                        <input type="text" className={`form-control`}
                                               onChange={(e) => setFacAdCity(e.target.value)} value={facAdCity}/>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">Code postal</span>
                                            <input type="number" className={`form-control`}
                                                   onChange={(e) => setFacAdCodePostal(e.target.value)}
                                                   value={facAdCodePostal}/>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>Adresse | Rue 1 | Rue
                                            2</label>
                                        <textarea onChange={(e) => setFacAdOthers(e.target.value)} value={facAdOthers}
                                                  className="form-control" rows="3" defaultValue=''></textarea>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label className="custom-control custom-radio">
                                            <input type="checkbox" className="custom-control-input"
                                                   name="example-radios"
                                                   value="option1" onChange={(e) => setDisplay(!display)}/>
                                            <span className="custom-control-label">Utiliser l'addresse de facturation comme adresse de livraison</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <label htmlFor="exampleInputEmail1">Taxe</label>*/}
                            {/*    <div className="input-group mb-3">*/}
                            {/*        <select className="form-select" id="inputGroupSelect01">*/}
                            {/*            <option selected>Séléctionnez une taxe</option>*/}
                            {/*            <option value="1">One</option>*/}
                            {/*            <option value="2">Two</option>*/}
                            {/*            <option value="3">Three</option>*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                    <div className="card" style={{display: (display) ? 'none' : 'block'}}>
                        <div className="card-header">
                            <h3 className="card-title">ADRESSE DE LIVRAISON</h3>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">Pays / Région</span>
                                            <input type="text" className={`form-control`}
                                                   onChange={(e) => setLivAdCountry(e.target.value)}
                                                   value={livAdCountry}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>Ville</label>
                                        <input type="text" className={`form-control`}
                                               onChange={(e) => setLivAdCity(e.target.value)} value={livAdCity}/>
                                    </div>
                                </div>

                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname" className=""></label>
                                        <div className="input-group mb-3">
                                            <span className="input-group-text">Code postal</span>
                                            <input type="number" className={`form-control`}
                                                   onChange={(e) => setLivAdCodePostal(e.target.value)}
                                                   value={livAdCodePostal}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="exampleInputname1" className={``}>Adresse | Rue 1 | Rue
                                            2</label>
                                        <textarea className="form-control" rows="3" defaultValue=''
                                                  onChange={(e) => setLivAdOthers(e.target.value)}
                                                  value={livAdOthers}></textarea>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <label htmlFor="exampleInputEmail1">Taxe</label>*/}
                            {/*    <div className="input-group mb-3">*/}
                            {/*        <select className="form-select" id="inputGroupSelect01">*/}
                            {/*            <option selected>Séléctionnez une taxe</option>*/}
                            {/*            <option value="1">One</option>*/}
                            {/*            <option value="2">Two</option>*/}
                            {/*            <option value="3">Three</option>*/}
                            {/*        </select>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                    <div className="card">
                        <div className="card-footer">
                            <div className="row">

                                <div className="col-md-12">
                                    <button disabled={isSubmit} type="button" className="btn btn-primary"
                                       onClick={Save}>{isSubmit ? t("Loading ...") : t("Enregistrer")}</button>
                                    {props.ocr ? null : (<a 
                                        onClick={()=>{
                                            navigate(-1);
                                        }}
                                    className="btn btn-default float-end">Annuler</a>)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpClient;